<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import { messageLogin, messageLoginEmpty } from '@/event/account/alert/messageLogin'
import { toggleAlertLogin } from '@/event/account/alert/showAlertLogin'
import ButtonLinkRegisterHappy from '../../register/button/ButtonLinkRegisterHappy.vue'

function toggleAlertLoginHappy() {
    messageLogin.value = messageLoginEmpty
}
console.log(messageLogin.value)
</script>

<template>
    <section class="section-message-alert-login-happy">
        <div class="div-overlay-login-alert-happy" @click="toggleAlertLoginHappy"></div>
        <div
            v-if="messageLogin.errors && messageLogin.errors.length > 0"
            :class="messageLogin.class ? messageLogin.class : 'hidden'"
            class=""
        >
            <div :class="`div-header-alert-login-happy-${messageLogin.class}`">
                <ButtonClose
                    :function="toggleAlertLogin"
                    :hover-color="
                        messageLogin.class === 'success' ? 'success-happy' : 'error-happy'
                    "
                />
            </div>
            <div class="div-content-alert-login-happy">
                <ul
                    v-for="(error, index) in messageLogin.errors"
                    :key="index"
                    class="bullet-happy"
                >
                    <li class="font-semibold text-base">{{ error }}</li>
                </ul>
                <div v-if="messageLogin.action == 'not-exist'" class="pt-3">
                    <!-- <ButtonLinkRegister /> -->
                </div>
            </div>
        </div>
        <div v-else :class="messageLogin.class ? messageLogin.class : 'hidden'" class=" ">
            <div :class="`div-header-alert-login-happy-${messageLogin.class}`">
                <ButtonClose
                    :function="toggleAlertLogin"
                    :hover-color="
                        messageLogin.class === 'success' ? 'success-happy' : 'error-happy'
                    "
                />
            </div>
            <div class="div-content-alert-login-happy">
                <p class="text-center font-semibold">
                    {{ messageLogin.message }}
                </p>
                <div
                    v-if="messageLogin.action == 'not-exist'"
                    class="pt-4 w-full flex justify-center"
                >
                    <!-- <ButtonLinkRegister v-if="isThemeDefault" /> -->
                    <ButtonLinkRegisterHappy />
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.section-message-alert-login-happy {
    @apply fixed w-full h-full z-20 flex justify-center font-medium;
}

.div-overlay-login-alert-happy {
    @apply w-full h-full;
}

.error {
    @apply absolute z-10 bg-border-red-happy-light rounded-md pb-2 flex flex-col items-center justify-center gap-2 min-w-[19rem] max-w-[19rem] max-h-fit mt-48 text-bg-happy-light;
}

.success {
    @apply absolute z-10 bg-green-happy rounded-md pb-2 flex flex-col items-center justify-center gap-2 min-w-[19rem] max-w-[19rem] max-h-fit mt-48 text-text-dark-happy-light;
}

.div-header-alert-login-happy-error {
    @apply flex flex-col items-end bg-header-red-happy w-full rounded-t-md px-3 py-2;
}

.div-header-alert-login-happy-success {
    @apply flex flex-col items-end bg-green-light-happy w-full rounded-t-md px-3 py-2;
}

.div-content-alert-login-happy {
    @apply px-3 py-2;
}

.bullet-happy {
    @apply relative pl-3 list-disc;
}
</style>
